/* eslint-disable import/prefer-default-export */
import { useTranslate } from '@tolgee/react';
import MobileCaptchaForm, { MobileCaptchaFormProps } from 'components/MobileCaptchaForm';
import { OpenModalOfContentProps } from '../openModalOfContent';
import { Button } from 'antd';
import OpenModalOfContent from '../openModalOfContent';

export interface OnlyPhoneFormModalProps extends Partial<OpenModalOfContentProps> {
  formProps: MobileCaptchaFormProps;
}

export const OnlyPhoneFormModal = ({ formProps, ...otherProps }: OnlyPhoneFormModalProps) => {
  const { initialValues } = formProps;
  const { t } = useTranslate();

  const props = {
    title: t('modals.帐号信息'),
    subTitle: initialValues?.mobile !== undefined ? t('modals.修改手机号') : t('modals.设置手机号'),
    desc: <></>,
    ...otherProps,
    content: (
      <MobileCaptchaForm labelLess {...formProps}>
        <Button className="w-full mt-4" type="primary" htmlType="submit">
          {t('modals.确认修改')}
        </Button>
        {otherProps?.content}
      </MobileCaptchaForm>
    ),
  };

  return <OpenModalOfContent {...props} />;
};
